export default {
  BASE: 'BASE',
  TAXES: 'TAXES',
  CHARGES: 'CHARGES',
  FARES_DIFFERENCE: 'FARES_DIFFERENCE',
  OPERATION_CHARGES: 'OPERATION_CHARGES',
  DISCOUNT: 'DISCOUNT'
}
